import headers from './headers'

export default function(fetch) {
  return function(file) {
    const h = headers()
    h.delete('Content-type')

    const formData = new FormData()
    formData.append('file', file)
    formData.append('order', `/orders/${localStorage.getItem('order_id')}`)

    return fetch(`${process.env.REACT_APP_API_URL}/order_images`, {
      headers: h,
      method: 'POST',
      body: formData,
    }).then(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/repositories/uploadPhoto.js